import React from "react";
var __jsx = React.createElement;
import stl from './ReturnThankYouPage.module.css';
import DeskTopBlueMobileWhiteHeader from "@/components/sharedComponents/DeskTopBlueMobileWhiteHeader/DeskTopBlueMobileWhiteHeader";
import { CDN_LINK } from "@globalConfig";
import AnyQuestion from "@/pages/faqs/FaqComponents/AnyQuestion";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { useTrackingReturnWizard } from "@/pages/tracking/trackingReturn/TrackingReturnWizardContext";
var ReturnThankYouPage = function ReturnThankYouPage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tLong = _useTranslation.tLong;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTrackingReturnWiz = useTrackingReturnWizard(),
    orderData = _useTrackingReturnWiz.orderData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: true,
    hideAppBanner: true,
    mobileNoLogo: true
  }, /*#__PURE__*/React.createElement(DeskTopBlueMobileWhiteHeader, {
    className2: stl.customBackground,
    title: t("submit_return_request", {
      ns: "web_tracking_finance"
    }),
    hideMobile: true,
    onClick: function onClick() {
      return navigateTo("/tracking-landing");
    }
  }), /*#__PURE__*/React.createElement("section", {
    className: stl.grid
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.card
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imageBox
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.returnImage,
    src: CDN_LINK + '/assets/images/done.svg',
    alt: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.headerBox
  }, /*#__PURE__*/React.createElement("h2", {
    className: stl.header
  }, t("request_submitted_successfully", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.description
  }, tLong("tracking/return-success-description", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.returnButtonBox
  }, /*#__PURE__*/React.createElement("a", {
    className: stl.returnButton,
    onClick: function onClick() {
      return navigateTo("".concat(orderData !== null && orderData !== void 0 && orderData.isFinance ? "/tracking-finance-details" : "/tracking-checkout-details", "/").concat(orderData === null || orderData === void 0 ? void 0 : orderData.order_id));
    }
  }, t("go_back_track_order", {
    ns: "web_tracking"
  })))), /*#__PURE__*/React.createElement("section", {
    className: stl.anyQuestionBox
  }, /*#__PURE__*/React.createElement(AnyQuestion, null)))));
};
export default ReturnThankYouPage;